export default {
  buybackSwapSummaryPriceNew: {
    id: 'buyback_swap_summary_price_new',
    defaultMessage: 'Buyback of {price}',
  },
  buybackSwapSummaryDelete: {
    id: 'buyback_swap_summary_delete',
    defaultMessage: 'Delete my buyback',
  },
  buybackSwapSummaryTitle: {
    id: 'buyback_swap_summary_title',
    defaultMessage: 'About the buyback',
  },
}
